import React from 'react';

import Tooltip from '@mui/material/Tooltip';

import { secondsToMinutesAndSeconds } from 'services/helpers/formatTime';

interface Props {
  children: React.ReactElement;
  open: boolean;
  value: number;
}

const ControlBarValueLabel: React.FC<Props> = ({ children, open, value }) => {
  const formattedValue = secondsToMinutesAndSeconds(value);

  return (
    <Tooltip open={open} enterTouchDelay={0} placement='top' title={formattedValue}>
      {children}
    </Tooltip>
  );
};

export default ControlBarValueLabel;
